import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import { fetchLandingConfig, readLandingConfigCache } from '../utils/landingConfig';

const FALLBACK = {
  homeLandingEnabled: true,
  defaultCupSlug: 'worldcup',
  heroFeaturedMatch: null,
  heroFeaturedMatchId: null,
};

/**
 * Resolves `/` from admin setting homeLandingEnabled:
 * - enabled → Home hub (paint immediately from cache / optimistic Home)
 * - disabled → first cup in navbar drag order (fallback worldcup)
 */
const LandingRedirect = () => {
  const [state, setState] = useState(() => {
    const cached = readLandingConfigCache();
    return {
      ...FALLBACK,
      ...(cached || {}),
      landingResolved: Boolean(cached),
    };
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchLandingConfig({ timeout: 5000 });
        if (cancelled) return;
        setState({ ...data, landingResolved: true });
      } catch (err) {
        console.warn('[Landing] Could not load landing config:', err?.message || err);
        if (cancelled) return;
        setState((prev) => ({
          ...prev,
          landingResolved: true,
          homeLandingEnabled: prev.homeLandingEnabled !== false,
        }));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!state.homeLandingEnabled) {
    return <Navigate to={`/cup/${state.defaultCupSlug || 'worldcup'}`} replace />;
  }

  return (
    <Home
      heroFeaturedMatch={state.heroFeaturedMatch}
      heroFeaturedMatchId={state.heroFeaturedMatchId}
      landingResolved={state.landingResolved}
    />
  );
};

export default LandingRedirect;
